import { Navigate, Outlet } from "react-router-dom";
import { useUserCapabilities } from "../../auth.capabilities";

export const ProtectedRoute = ({ allowedRoles, redirectTo = "/" }) => {
  const { role } = useUserCapabilities();

  if (!allowedRoles?.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
